module.exports = __webpack_public_path__ + "img/arrow-down.15b6746b.svg";